/**
 * The titles of the Leistungsverzeichnis's 224 sections, for the ⓘ that `LvRef` draws
 * where a screen cites one: "§9 · Mandanten- und Organisationsstruktur" says what the
 * reference is about, where "LV §9" alone told nobody outside the project anything.
 *
 * Transcribed from docs/07-requirements-index.md, which transcribes the PDF.
 * `tests/unit/lv-sections.test.ts` compares the two in both directions, so a title
 * corrected there fails the suite until it is corrected here as well.
 */
export const LV_SECTION_TITLES: Readonly<Record<number, string>> = {
  1: "Zweck dieses Dokuments",
  2: "Übergeordnetes Projektziel",
  3: "Fachliche Grundprinzipien",
  4: "Nichtfunktionale Hauptziele",
  5: "Verbindliche Zielarchitektur",
  6: "Verbindlicher Technologie-Stack",
  7: "Grundsatz der Softwarearchitektur",
  8: "Ablösung der aktuellen Browserdatenhaltung",
  9: "Mandanten- und Organisationsstruktur",
  10: "Grundregeln des Datenmodells",
  11: "Soft Delete",
  12: "Unternehmensdaten",
  13: "Standorte",
  14: "Technische Anlagenobjekte",
  15: "Asset-Hierarchie",
  16: "Objektstatus",
  17: "Digitale Lebenslaufakte",
  18: "Benutzer",
  19: "Rollenmodell",
  20: "Permission-Modell",
  21: "Standortbezogene Berechtigungen",
  22: "Teams und Organisationseinheiten",
  23: "Qualifikationen",
  24: "Qualifikationsnachweise",
  25: "Qualifikationsprüfung vor Auftragsbeginn",
  26: "Instandhaltungsauftrag",
  27: "Auftragsarten",
  28: "Prioritäten",
  29: "Auftragsstatusautomat",
  30: "Statusregeln",
  31: "Auftragsvorgänge",
  32: "Standardarbeitspläne",
  33: "Versionierung von Arbeitsplänen",
  34: "Wartungsplan",
  35: "Terminierungsarten",
  36: "Quelle eines Wartungsintervalls",
  37: "Automatischer Wartungsabruf",
  38: "Idempotenz des Schedulers",
  39: "Wartungsplanabrufe",
  40: "Zählerverwaltung",
  41: "Inspektionen",
  42: "Inspektionsstatus",
  43: "Inspektionsvorlagen",
  44: "Feldtypen von Checklisten",
  45: "Inspektionsbefunde",
  46: "Automatische Folgemaßnahmen",
  47: "Messwerte",
  48: "Messmittel",
  49: "Störmeldung",
  50: "Störungsprozess",
  51: "Wiederholstörungen",
  52: "Root Cause Analysis",
  53: "Kritikalitätsmodell",
  54: "Kritikalitätsscore",
  55: "Klassifizierung",
  56: "RCM-/Strategiebewertung",
  57: "Strategiealgorithmus",
  58: "Arbeitssicherheit",
  59: "Arbeitsfreigaben",
  60: "Freigabebedingung",
  61: "LOTO",
  62: "Fremdfirmen",
  63: "Fremdfirmenportal",
  64: "Ersatzteile",
  65: "Material-Asset-Zuordnung",
  66: "Lagerorte",
  67: "Bestände",
  68: "Bestandsberechnung",
  69: "Mindestbestand",
  70: "Materialreservierung",
  71: "Dokumentenmanagement",
  72: "Dokumentstatus",
  73: "Dokumenttypen",
  74: "Dokumentverknüpfungen",
  75: "Dateisicherheit",
  76: "Unveränderlichkeit freigegebener Nachweise",
  77: "Hash-basierter Dokumentennachweis",
  78: "Elektronische Freigabe",
  79: "Revisionen und Stillstände",
  80: "Revisions-Gates",
  81: "Gate-Kriterien",
  82: "Revisionsmaßnahmen",
  83: "Regelwerksregister",
  84: "Norm-/Regelwerksdaten",
  85: "Normative Prüfung",
  86: "Compliance-Anforderung",
  87: "Compliance-Status",
  88: "Dashboard",
  89: "Dashboard-KPIs",
  90: "KPI-System",
  91: "Technische KPIs",
  92: "Planungs-KPIs",
  93: "Kosten-KPIs",
  94: "Qualitäts-KPIs",
  95: "Historisierung von KPIs",
  96: "Portfolio-Zustand",
  97: "Benachrichtigungen",
  98: "Ereignisse für Benachrichtigungen",
  99: "Eskalationsregeln",
  100: "Kommunikationskanäle",
  101: "Audit Trail",
  102: "Audit-Aktionen",
  103: "Audit-Manipulationsschutz",
  104: "Änderungsgrund",
  105: "Optimistic Locking",
  106: "Nummernkreise",
  107: "REST-API",
  108: "Site-Endpunkte",
  109: "Asset-Endpunkte",
  110: "Auftragsendpunkte",
  111: "Wartungsplan-Endpunkte",
  112: "Inspektions-Endpunkte",
  113: "Material-Endpunkte",
  114: "Dokument-Endpunkte",
  115: "Reporting-Endpunkte",
  116: "API-Datumsformat",
  117: "Geldwerte",
  118: "API-Fehlerformat",
  119: "HTTP-Statuscodes",
  120: "Suche",
  121: "Serverfilter",
  122: "Pagination",
  123: "Frontend-Grundlayout",
  124: "Frontend-Komponenten",
  125: "Keine Inline-Editoren",
  126: "Formvalidierung",
  127: "Offlinefähigkeit",
  128: "Offline-Datenspeicher",
  129: "Synchronisationsstatus",
  130: "Synchronisationsstrategie",
  131: "Konfliktbehandlung",
  132: "Fotos offline",
  133: "Sicherheitsarchitektur",
  134: "Keine Vertrauenslogik im Frontend",
  135: "Authentifizierung",
  136: "Sessions",
  137: "Datenschutz",
  138: "Backup",
  139: "Restore",
  140: "Logging",
  141: "Keine sensiblen Daten in Logs",
  142: "Monitoring",
  143: "Background Jobs",
  144: "PDF-Nachweise",
  145: "Reports",
  146: "Standardberichte",
  147: "Excel-/CSV-Import",
  148: "Migration des bestehenden Prototyps",
  149: "Legacy-Import-Endpunkt",
  150: "Datenintegrität",
  151: "Datenbank-Foreign-Keys",
  152: "Löschregeln",
  153: "Performanceziel",
  154: "Indizes",
  155: "Datenbankmigration",
  156: "Entwicklungsumgebungen",
  157: "Containerisierung",
  158: "Konfiguration",
  159: "Repository-Struktur Backend",
  160: "Repository-Struktur Frontend",
  161: "API-Client",
  162: "Coding-Regeln",
  163: "Code Reviews",
  164: "Unit Tests",
  165: "Integration Tests",
  166: "End-to-End Tests",
  167: "Abnahmetest Standort/Asset",
  168: "Abnahmetest Wartungsplan",
  169: "Abnahmetest Auftrag",
  170: "Abnahmetest Inspektion",
  171: "Abnahmetest Qualifikation",
  172: "Abnahmetest Material",
  173: "Abnahmetest Dokument",
  174: "Abnahmetest Offline",
  175: "Abnahmetest Berechtigungen",
  176: "Abnahmetest Mehrbenutzerkonflikt",
  177: "Abnahmetest Audit",
  178: "CI/CD",
  179: "Deployment",
  180: "Versionsschema",
  181: "Feature Flags",
  182: "Schnittstellenarchitektur",
  183: "ERP-Vorbereitung",
  184: "SCADA-/IoT-Vorbereitung",
  185: "QR-Code",
  186: "Konfigurationsmodul",
  187: "Keine fachlichen Magic Values",
  188: "Continuous Improvement",
  189: "Wartungsplanoptimierung",
  190: "Datenanalyse",
  191: "Datenqualität",
  192: "Pflichtfeldkonzept",
  193: "Accessibility",
  194: "Responsive Design",
  195: "PWA-Installation",
  196: "Internationalisierung",
  197: "Zeitzonen",
  198: "Definition of Done je Feature",
  199: "MVP",
  200: "Phase 2 nach MVP",
  201: "Empfohlene Implementierungsreihenfolge",
  202: "Pilotierung",
  203: "Stammdatenmigration",
  204: "Migrationsprotokoll",
  205: "Betreiber- und Administratorhandbuch",
  206: "Entwicklerdokumentation",
  207: "Benutzerhandbuch",
  208: "OpenAPI-Dokumentation",
  209: "Datenbankdokumentation",
  210: "Sicherheitsprüfung vor Go-Live",
  211: "Produktivfreigabe",
  212: "Betrieb",
  213: "Supportmodell",
  214: "Datenaufbewahrung",
  215: "Archivierung",
  216: "Zeitliche Nachvollziehbarkeit",
  217: "Revisionssicherheit – Mindestdefinition",
  218: "Funktionale Kernkette",
  219: "Zweite Kernkette",
  220: "Fachlicher Systemgrundsatz",
  221: "Verbindlicher Architekturgrundsatz",
  222: "Vor Beginn der Programmierung vorzulegende Ergebnisse",
  223: "Nicht zulässige Umsetzung",
  224: "Definition des Endprodukts",
};
